import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="console"
export default class extends Controller {
  connect() {
    this.isConsoleOpen = false

    const collapse = () => this.setConsoleOpen(false)
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.whenConsoleReady(collapse), { once: true })
    } else {
      this.whenConsoleReady(collapse)
    }
  }

  toggleConsoleHeight() {
    this.whenConsoleReady(() => this.setConsoleOpen(!this.isConsoleOpen))
  }

  whenConsoleReady(callback) {
    const wait = () => {
      const consoleEl = document.getElementById("console")
      if (consoleEl?.classList.contains("console") && consoleEl.dataset.sessionId) {
        callback(consoleEl)
        return
      }
      requestAnimationFrame(wait)
    }
    wait()
  }

  setConsoleOpen(open) {
    const consoleEl = document.getElementById("console")
    if (!consoleEl) return

    this.isConsoleOpen = open
    consoleEl.classList.toggle("opened", open)

    if (open) {
      requestAnimationFrame(() => {
        document.body.style.marginBottom = `${consoleEl.offsetHeight}px`
      })
    } else {
      document.body.style.marginBottom = "0px"
    }
  }
}
